import { render, staticRenderFns } from "./PatientHistory.vue?vue&type=template&id=5bc019da&scoped=true&"
import script from "./PatientHistory.vue?vue&type=script&lang=js&"
export * from "./PatientHistory.vue?vue&type=script&lang=js&"
import style0 from "./PatientHistory.vue?vue&type=style&index=0&id=5bc019da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc019da",
  null
  
)

export default component.exports